import { render, staticRenderFns } from "./AddStartups.vue?vue&type=template&id=294f74be&scoped=true&"
import script from "./AddStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f74be",
  null
  
)

export default component.exports